import { useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from "../../engagement/Amplitude";

export default function TagBadge({ tag }: { tag: string }) {
  const navigate = useNavigate();
  return (
    <div
      className="badge badge-neutral cursor-pointer hover:text-white hover:bg-primary"
      onClick={(e) => {
        e.stopPropagation();
        logAnalyticsEvent("Click On Tag", {
          tag: tag,
        });
        navigate(`/search?q=tag:${tag}`);
      }}
    >
      {tag}
    </div>
  );
}
